import { useTranslation } from 'react-i18next';

/**
 * Suspense fallback for the lazy SchedulerPage chunk. Renders a minimal
 * placeholder so the user doesn't see a blank screen during cold-load
 * (typically <500ms). Intentionally lightweight — only i18n.
 */
export function SchedulerPageSkeleton() {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        color: 'var(--g500)',
        fontSize: 'var(--fs-sm)',
      }}
    >
      {t('scheduler.loading')}
    </div>
  );
}
